import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';


class CalcForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bathSizeX: 600,
            bathSizeY: 600,
            bathSizeZ: 300,

            selectedCoinFaceValue: 5,
            centsAvailable: 150000,
            coinVolume: 34,
        }
    }
    calcCoinVolume(coinFaceValue, centsAvailable) {
        //diameterMM, thicknessMM, weightGrams
        const COIN_DIMENSIONS = {
            1: [17.65, 1.4, 2.60],
            2: [21.59, 1.9, 5.20],
            5: [19.41, 1.3, 2.83],
            10: [23.60, 2.0,5.65],
            20: [28.65, 2.5,11.3],
            50: [31.65, 2.5, 15.55],
            100: [25.00, 3.0, 9.00],
            200: [20.50, 2.8, 6.60],
        }
        const coinData = COIN_DIMENSIONS[coinFaceValue];
        const radius = coinData[0] / 2
        const height = coinData[1]
        const singleCoinVolumeMMCube = Math.PI * radius * radius * height

        const numCoinsAfforded = Math.floor(centsAvailable/coinFaceValue)

        return singleCoinVolumeMMCube * numCoinsAfforded
    }
    getCoinColour(coinFaceValue) {
        if(coinFaceValue < 5)
            return "#cc6633"

        if(coinFaceValue < 100)
            return "#C0C0C0"

        return "#FFD700"
    }
    handleBathSizeChangeX = (event) => {
        this.setState({bathSizeX: event.target.value})
    }
    handleBathSizeChangeY = (event) => {
        this.setState({bathSizeY: event.target.value})
    }
    handleBathSizeChangeZ = (event) => {
        this.setState({bathSizeZ: event.target.value})
    }
    setSelectedCoinFaceValue = (coinFaceValue) =>{
        this.setState({selectedCoinFaceValue: coinFaceValue})
    }
    handleDollarsAvailableChange = (event) => {
        this.setState({centsAvailable: event.target.value*100})
    }
    render() {

        const availableCoinVolume = Math.floor(this.calcCoinVolume(
            this.state.selectedCoinFaceValue, this.state.centsAvailable))

        const fillHeightZ = Math.floor(availableCoinVolume / (this.state.bathSizeX * this.state.bathSizeY));

        const coinColour = this.getCoinColour(this.state.selectedCoinFaceValue)
        return <div>


            Coin 
            <button onClick={() => this.setSelectedCoinFaceValue(1)}>1c</button>
            <button onClick={() => this.setSelectedCoinFaceValue(2)}>2c</button>
            <button onClick={() => this.setSelectedCoinFaceValue(5)}>5c</button>
            <button onClick={() => this.setSelectedCoinFaceValue(10)}>10c</button>
            <button onClick={() => this.setSelectedCoinFaceValue(20)}>20c</button>
            <button onClick={() => this.setSelectedCoinFaceValue(50)}>50c</button>
            <button onClick={() => this.setSelectedCoinFaceValue(100)}>$1</button>
            <button onClick={() => this.setSelectedCoinFaceValue(200)}>$2</button>

            <br/>
            <br/>
            How much Money ($)
            <input type="text" value={this.state.centsAvailable/100} onChange={this.handleDollarsAvailableChange} />

            <br/>
            <br/>
            BathX(mm)
            <input type="text" value={this.state.bathSizeX} onChange={this.handleBathSizeChangeX} />

            BathY(mm)
            <input type="text" value={this.state.bathSizeY} onChange={this.handleBathSizeChangeY} />

            BathZ(mm)
            <input type="text" value={this.state.bathSizeZ} onChange={this.handleBathSizeChangeZ} />
            <br/>


            <BathDiagram
                bathSizeX={this.state.bathSizeX}
                bathSizeY={this.state.bathSizeY}
                bathSizeZ={this.state.bathSizeZ}

                fillHeightZ={fillHeightZ}

                coinColour={coinColour}
            />
        </div>
    }
}

class BathDiagram extends Component {

    xyzMMtoSVGRect(x, y, z, offsetX, offsetY, fill){
        return <rect x={offsetX} y={offsetY} width={x} height={z} fill={fill}/>
    }


    render() {

        const bathSizeX = this.props.bathSizeX;
        const bathSizeY = this.props.bathSizeY;
        const bathSizeZ = this.props.bathSizeZ;

        const fillHeightZ = this.props.fillHeightZ;

        const coinColour = this.props.coinColour;

        const bathRect = this.xyzMMtoSVGRect(bathSizeX, bathSizeY, bathSizeZ, 0, 0, "#000000")

        const coinFillRect = this.xyzMMtoSVGRect(bathSizeX, bathSizeY, fillHeightZ, 0, bathSizeZ-fillHeightZ, coinColour)
        return <div>

            <br/>
            Bath
            <svg style={{width:"100%", height:400}}>
                {bathRect}
                {coinFillRect}
            </svg>
        </div>
    }
}


class App extends Component {
  render() {
    return (
      <div className="App">
          <header className="App-header">

              <CalcForm
              />

              <img src="https://image.shutterstock.com/image-vector/illustration-woman-taking-bath-260nw-222598033.jpg"/>
        </header>
      </div>
    );
  }
}

export default App;
